import "./blog.css";

import React from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { ROUTES, SITE_URL } from "../../data/content";
import { POSTS, getPost } from "../../data/blog";
import PageMeta from "../general/PageMeta";
import NotFound from "../general/NotFound";
import { PostMeta } from "./Blog";

const BlogPost = () => {
  const { slug } = useParams();
  const post = getPost(slug);

  if (!post) {
    return (
      <NotFound />
    );
  }

  const others = POSTS.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <section className={"blog-page"}>
      <PageMeta
        title={post.title}
        description={post.excerpt}
      />
      <Helmet>
        <script type={"application/ld+json"}>
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: post.title,
            datePublished: post.date,
            author: { "@type": "Organization", name: "about U Financial Advisors" },
            image: `${SITE_URL}${post.cover}`,
            mainEntityOfPage: `${SITE_URL}${ROUTES.POST}/${post.slug}`,
          })}
        </script>
      </Helmet>

      <div className={"blog-container container"}>
        <nav
          className={"post-breadcrumb"}
          aria-label={"Breadcrumb"}
        >
          <Link to={ROUTES.BLOG}>All Posts</Link>
        </nav>

        <article className={"post"}>
          <PostMeta post={post} />
          <h1 className={"post-title"}>{post.title}</h1>
          <img
            src={post.cover}
            alt={post.coverAlt || ""}
            className={"post-cover"}
          />
          <div
            className={"post-body"}
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </article>

        {others.length > 0 ? (
          <aside className={"post-more"}>
            <div className={"post-more-header"}>
              <h2>Recent Posts</h2>
              <Link to={ROUTES.BLOG}>See All</Link>
            </div>
            <ul className={"post-more-list"}>
              {others.map((other) => (
                <li key={other.slug}>
                  <Link to={`${ROUTES.POST}/${other.slug}`}>
                    <img
                      src={other.cover}
                      alt={""}
                      loading={"lazy"}
                    />
                    <span>{other.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </aside>
        ) : null}
      </div>
    </section>
  );
};

export default BlogPost;
